import React, { FC } from 'react';
import ExternalContinueCard from '@components/acca/test/list/continueList/ExternalContinueCard';
import JobdaContinueCard from '@components/acca/test/list/continueList/JobdaContinueCard';
import { useUserInfo } from '@repository/auth/useUserInfo';
import styles from '@components/acca/test/list/accaTestList.module.scss';
import ApplyHistoryListVO from '@domain/vo/acca/test/ApplyHistoryListVO';
import { AccaModalType } from '@domain/constant/acca/AccaModalType';

import classnames from 'classnames/bind';
const cx = classnames.bind(styles);

const NoDataArea = () => {
  return <div className={cx('emptyArea')}>응시 이력이 없습니다.</div>;
};

interface IContinueListProps {
  applyHistoryData?: ApplyHistoryListVO;
  setModalState: (type: AccaModalType) => void;
}

const ContinueList: FC<IContinueListProps> = ({ applyHistoryData, setModalState }) => {
  const { data: userInfo } = useUserInfo();
  const userName = userInfo?.name ?? '회원';

  if (!applyHistoryData) return null;
  if (!applyHistoryData.applies?.length) return <NoDataArea />;

  const { applies, url } = applyHistoryData;

  const continueCardEl = applies.map((item, idx) => {
    if (item.externalYn) {
      return (
        <ExternalContinueCard
          key={item.sn}
          applyUrl={url}
          userName={userName}
          applyHistoryData={item}
          setModalState={setModalState}
        />
      );
    } else {
      return (
        <JobdaContinueCard
          key={item.sn}
          applyUrl={url}
          userName={userName}
          applyHistoryData={item}
          setModalState={setModalState}
        />
      );
    }
  });

  return <>{continueCardEl}</>;
};

export default ContinueList;
